<template>
    <h1 class="title">⛄스노맨 선납이연 날짜 계산기</h1>
    <div class="accordion" id="accordionExample">
        <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
                <button
                    class="accordion-button"
                    :class="!isManualActive ? 'collapsed' : ''"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    :aria-expanded="isManualActive"
                    aria-controls="collapseOne"
                    @click="isManualActive = !isManualActive"
                >
                    계산기 사용법에 대해 알려주세요!
                </button>
            </h2>
            <div
                id="collapseOne"
                class="accordion-collapse collapse"
                :class="isManualActive ? 'show' : ''"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
            >
                <div class="accordion-body">
                    <h4 class="accordion--headding--tertiary">목적</h4>
                    <p>
                        이 계산기는 <b>선납이연(先納移延)</b>을 활용할 때, 어떤
                        날짜에 납입해야 하는지 쉽게 알기 위해 제작되었습니다.
                    </p>
                    <p>
                        직접 복잡한 계산을 할 필요 없이, 자신의 상황에 맞게
                        항목을 입력하면 자동으로 최적의 납입 일정이 계산됩니다.
                    </p>
                    <h4 class="accordion--headding--tertiary">선납이연이란?</h4>
                    <p>
                        일반적으로 적금은 매달 일정 금액을 납입하는 방식으로
                        운영됩니다.
                    </p>
                    <p>하지만 선납(先納) 또는 이연(移延) 방식을 활용하면,</p>
                    <p>
                        <b>한꺼번에 미리 납입(선납)</b>하거나
                        <b>나중에 몰아서 납입(이연)</b>할 수 있어 자금 상황에
                        맞게 유연한 운용이 가능합니다.
                    </p>
                    <p>
                        특히, 선납이 가능한 자금을 높은 금리의 예금에
                        예치하면서, 적금과 예금 양쪽에서 이자를 받을 수 있어 더
                        높은 수익을 기대할 수 있습니다.
                    </p>
                    <p>
                        더 자세한 설명은 유튜브나 블로그에서 검색하시면 다양한
                        사례를 확인할 수 있습니다.
                    </p>
                    <h4 class="accordion--headding--tertiary">사용 방법</h4>
                    <ol>
                        <li>
                            <strong>적금기간</strong>: 적금의 총 가입 기간을
                            선택합니다.
                        </li>
                        <li>
                            <strong>납입방식</strong>: 매달 정기 납입 / 선납 /
                            이연 등 자금 상황에 맞는 방식을 선택합니다.
                        </li>
                        <li>
                            <strong>월 납입액</strong>: 매달 납입할 금액을
                            입력합니다.
                        </li>
                        <li>
                            <strong>금리</strong>: 가입할 적금의 금리를
                            입력하고, 단리/복리 옵션을 선택합니다.
                        </li>
                        <li>
                            <strong>가입일</strong>: 적금을 최초로 가입하고 첫
                            회차를 납입할 날짜를 선택합니다.
                        </li>
                        <li>
                            <strong>이자세율</strong>: 이자에 대한 세율을
                            선택하여 실제 수익을 예측할 수 있습니다.
                        </li>
                    </ol>
                    <p>
                        📌 이 계산기를 활용하여 가장 효율적인 적금 납입 전략을
                        세워보세요! 😊
                    </p>
                </div>
            </div>
        </div>
    </div>
    <form @submit.prevent="handleSubmit">
        <table class="data-table table table-striped table-bordered">
            <tbody>
                <tr>
                    <th scope="row">
                        <label> 적금기간 </label>
                    </th>
                    <td>
                        <div class="period form-check form-check-inline">
                            <input
                                type="radio"
                                class="form-check-input"
                                name="period"
                                id="year"
                                value="12"
                                v-model="period"
                                required
                            />
                            <label for="year">12개월</label>
                        </div>
                        <div class="period form-check form-check-inline">
                            <input
                                type="radio"
                                class="form-check-input"
                                name="period"
                                id="year-and-half"
                                value="18"
                                v-model="period"
                                required
                            />
                            <label for="year-and-half">18개월</label>
                        </div>
                        <div class="period form-check form-check-inline">
                            <input
                                type="radio"
                                class="form-check-input"
                                name="period"
                                id="twenty-three-months"
                                value="23"
                                v-model="period"
                            />
                            <label for="twenty-three-months">23개월</label>
                        </div>
                        <div class="period form-check form-check-inline">
                            <input
                                type="radio"
                                class="form-check-input"
                                name="period"
                                id="two-years"
                                value="24"
                                v-model="period"
                            />
                            <label for="two-years">24개월</label>
                        </div>
                        <div class="period form-check form-check-inline">
                            <input
                                type="radio"
                                class="form-check-input"
                                name="period"
                                id="three-years"
                                value="36"
                                v-model="period"
                            />
                            <label for="three-years">36개월</label>
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>
                        <label for="strategy"> 납입방식 </label>
                    </th>
                    <td v-if="period === '12'">
                        <div
                            class="form-check form-check-inline"
                            v-for="option in strategyOptions.oneYear"
                            :key="option"
                        >
                            <input
                                type="radio"
                                class="form-check-input"
                                name="strategies"
                                :id="option"
                                :value="option"
                                v-model="strategy"
                                required
                            />
                            <label :for="option">{{ option }}</label>
                        </div>
                    </td>

                    <td v-else-if="period === '18'">
                        <div
                            class="form-check form-check-inline"
                            v-for="option in strategyOptions.oneYearAndHalf"
                            :key="option"
                        >
                            <input
                                type="radio"
                                class="form-check-input"
                                name="strategies"
                                :id="option"
                                :value="option"
                                v-model="strategy"
                                required
                            />
                            <label :for="option">{{ option }}</label>
                        </div>
                    </td>

                    <td v-else-if="period === '23'">
                        <div
                            class="form-check form-check-inline"
                            v-for="option in strategyOptions.twentyThreeMonths"
                            :key="option"
                        >
                            <input
                                type="radio"
                                class="form-check-input"
                                name="strategies"
                                :id="option"
                                :value="option"
                                v-model="strategy"
                                required
                            />
                            <label :for="option">{{ option }}</label>
                        </div>
                    </td>

                    <td v-else-if="period === '24'">
                        <div
                            class="form-check form-check-inline"
                            v-for="option in strategyOptions.twoYears"
                            :key="option"
                        >
                            <input
                                type="radio"
                                class="form-check-input"
                                name="strategies"
                                :id="option"
                                :value="option"
                                v-model="strategy"
                                required
                            />
                            <label :for="option">{{ option }}</label>
                        </div>
                    </td>

                    <td v-else-if="period === '36'">
                        <div
                            class="form-check form-check-inline"
                            v-for="option in strategyOptions.threeYears"
                            :key="option"
                        >
                            <input
                                type="radio"
                                class="form-check-input"
                                name="strategies"
                                :id="option"
                                :value="option"
                                v-model="strategy"
                                required
                            />
                            <label :for="option">{{ option }}</label>
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>
                        <label for="price">월 납입액</label>
                    </th>
                    <td>
                        <div class="form-check form-check-inline">
                            <input
                                type="number"
                                name="price"
                                id="price"
                                min="0"
                                max="10000000000"
                                v-model="price"
                                required
                            />
                            원
                            <p class="price__comma">
                                {{
                                    this.price >= 10000 * 10000
                                        ? `${setComma(
                                              this.price / (10000 * 10000)
                                          )}억원`
                                        : this.price >= 100000
                                        ? `${setComma(this.price / 10000)} 만원`
                                        : this.price
                                        ? `${setComma(this.price)} 원`
                                        : ""
                                }}
                            </p>
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>
                        <label for="rate"> 금리 </label>
                    </th>
                    <td>
                        <div class="form-check form-check-inline">
                            <input
                                type="number"
                                name="rate"
                                id="rate"
                                step="0.01"
                                min="0"
                                max="100"
                                v-model="rate"
                                required
                            />
                            %
                        </div>
                        <div class="form-check form-check-inline">
                            <input
                                type="radio"
                                class="form-check-input"
                                name="interestType"
                                id="simple"
                                value="simple"
                                v-model="interestType"
                                required
                            />
                            <label for="simple">단리</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input
                                type="radio"
                                class="form-check-input"
                                name="interestType"
                                id="compound"
                                value="compound"
                                v-model="interestType"
                            />
                            <label for="compound">복리</label>
                        </div>
                    </td>
                </tr>

                <tr>
                    <th>
                        <label for="start-date"> 가입일 </label>
                    </th>
                    <td>
                        <div class="form-check form-check-inline">
                            <input
                                type="date"
                                name="start-date"
                                id="start-date"
                                placeholder="yyyy-mm-dd"
                                v-model="startDate"
                                required
                            />
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>이자세율</th>
                    <td>
                        <div class="form-check form-check-inline">
                            <input
                                type="radio"
                                class="form-check-input"
                                name="tax"
                                id="normal"
                                :value="taxType.normal"
                                v-model="tax"
                                required
                            />
                            <label for="normal">15.4%</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input
                                type="radio"
                                class="form-check-input"
                                name="tax"
                                id="low"
                                :value="taxType.low"
                                v-model="tax"
                                required
                            />
                            <label for="low">1.4%</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input
                                type="radio"
                                class="form-check-input"
                                name="tax"
                                id="noTax"
                                :value="taxType.noTax"
                                v-model="tax"
                                required
                            />
                            <label for="noTax">0%</label>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="text-center">
            <button class="btn btn-primary">계산하기</button>
        </div>
    </form>
    <div class="adfit">
        <KakaoAds />
    </div>

    <h2 class="heading__secondary">결과</h2>
    <div class="caution" v-if="isResultFetched">
        <p class="caution__text">
            계산 결과는 참고용이며 이용자의 판단에 따른 투자수익 및 정보의
            오류등에 따른 손익에 대해서는 책임지지 않습니다.
        </p>
    </div>
    <div class="result" v-if="isResultFetched">
        <div
            class="modal show"
            id="dateModal"
            tabindex="-1"
            aria-labelledby="dateModalLabel"
            style="display: block"
            v-if="isModalOn"
            @click.self="isModalOn = false"
        >
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="dateModalLabel">
                            변경 가능한 납입일
                        </h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            @click.prevent="isModalOn = false"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <h5>이 날짜들은 무엇인가요?</h5>
                        <p class="modal__explain">
                            아래 보이는 날짜들은 변경이 가능한 납입일입니다.
                        </p>
                        <p class="modal__explain">
                            해당 날짜들은 만기 지연일수가 0인 날짜들이며, 총
                            지연일(선납일 + 이연일)은 0일에 가까울수록 바람직한
                            상황입니다.
                        </p>
                        <p class="modal__explain">
                            총 지연일이 음수일 경우 기존 만기일에 돈을 찾을 수
                            있지만, 총 지연일이 양수인 경우에는 그만큼 납입이
                            지연된 것이므로 만기일도 늦춰지게 됩니다.
                        </p>
                        <hr />
                        <table class="date-modal-table">
                            <thead>
                                <tr>
                                    <th scope="col">납입일</th>
                                    <th scope="col">총 지연일</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="item in result.dateItems"
                                    :key="item"
                                >
                                    <td>{{ item[0] }}</td>
                                    <td>{{ item[1] }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal"
                            @click.prevent="isModalOn = false"
                        >
                            닫기
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <ul
            class="result__details list-group list-group-horizontal-lg"
            v-if="result.secondPayDate"
        >
            <li class="list-group-item">
                <span>첫 납입일</span>
            </li>
            <li class="list-group-item">
                <span>{{ this.result.firstPayDate }} </span>
            </li>
            <li class="list-group-item">
                <span>납입액 </span>
                <span class="result-price">
                    {{ setComma(this.price * this.strategyArr[0]) }}
                </span>
                <span>원</span>
            </li>
        </ul>
        <ul
            class="result__details list-group list-group-horizontal-lg"
            v-if="result.secondPayDate"
        >
            <li class="list-group-item">
                <span>둘째 납입일</span>
            </li>
            <li class="list-group-item">
                <span>{{ this.result.secondPayDate }} </span>
            </li>
            <li class="list-group-item">
                <span>납입액 </span>
                <span class="result-price">
                    {{ setComma(this.price * this.strategyArr[1]) }}
                </span>
                <span>원</span>
            </li>
        </ul>
        <ul
            class="result__details list-group list-group-horizontal-lg"
            v-if="result.secondPayDate"
        >
            <li class="list-group-item">
                <span>중간 납입일</span>
            </li>
            <li class="list-group-item">
                <span>{{ this.result.optimizedDate[0] }} </span>
            </li>
            <li class="list-group-item">
                <span>납입액 </span>
                <span class="result-price">
                    {{ setComma(this.price * this.strategyArr[2]) }}
                </span>
                <span>원</span>
                <button
                    type="button"
                    class="btn btn-link btn__more-dates"
                    data-bs-toggle="modal"
                    data-bs-target="#dateModal"
                    @click.prevent="isModalOn = true"
                >
                    다른 날짜에 납입하고 싶다면?
                </button>
            </li>
        </ul>
        <ul
            class="result__details list-group list-group-horizontal-lg"
            v-if="result.secondPayDate"
        >
            <li class="list-group-item">
                <span>마지막 납입일</span>
            </li>
            <li class="list-group-item">
                <span>{{ this.result.lastPayDate }} </span>
            </li>
            <li class="list-group-item">
                <span>납입액 </span>
                <span class="result-price">
                    {{ setComma(this.price * this.strategyArr[3]) }}
                </span>
                <span>원</span>
            </li>
        </ul>

        <ul
            class="result__details list-group list-group-horizontal-lg"
            v-if="result.lastPayDate"
        >
            <li class="list-group-item">
                <span>첫 납입일</span>
            </li>
            <li class="list-group-item">
                <span>{{ this.result.firstPayDate }} </span>
            </li>
            <li class="list-group-item">
                <span>납입액 </span>
                <span class="result-price">
                    {{ setComma(this.price * this.strategyArr[0]) }}
                </span>
                <span>원</span>
            </li>
        </ul>
        <ul
            class="result__details list-group list-group-horizontal-lg"
            v-if="result.lastPayDate"
        >
            <li class="list-group-item">
                <span>중간 납입일</span>
            </li>
            <li class="list-group-item">
                <span>{{ this.result.optimizedDate[0] }} </span>
            </li>
            <li class="list-group-item">
                <span>납입액 </span>
                <span class="result-price">
                    {{ setComma(this.price * this.strategyArr[1]) }}
                </span>
                <span>원</span>
                <button
                    type="button"
                    class="btn btn-link btn__more-dates"
                    data-bs-toggle="modal"
                    data-bs-target="#dateModal"
                    @click.prevent="isModalOn = true"
                >
                    다른 날짜에 납입하고 싶다면?
                </button>
            </li>
        </ul>
        <ul
            class="result__details list-group list-group-horizontal-lg"
            v-if="result.lastPayDate"
        >
            <li class="list-group-item">
                <span>마지막 납입일</span>
            </li>
            <li class="list-group-item">
                <span>{{ this.result.lastPayDate }} </span>
            </li>
            <li class="list-group-item">
                <span>납입액 </span>
                <span class="result-price">
                    {{ setComma(this.price * this.strategyArr[2]) }}
                </span>
                <span>원</span>
            </li>
        </ul>

        <ul
            class="result__details list-group list-group-horizontal-lg"
            v-else-if="!result.lastPayDate"
        >
            <li class="list-group-item">
                <span>첫 납입일</span>
            </li>
            <li class="list-group-item">
                <span>{{ this.result.firstPayDate }} </span>
            </li>
            <li class="list-group-item">
                <span>납입액 </span>
                <span class="result-price">
                    {{ setComma(this.price * this.strategyArr[0]) }}
                </span>
                <span>원</span>
            </li>
        </ul>
        <ul
            class="result__details list-group list-group-horizontal-lg"
            v-if="!result.lastPayDate"
        >
            <li class="list-group-item">
                <span>마지막 납입일</span>
            </li>
            <li class="list-group-item">
                <span>{{ this.result.optimizedDate[0] }} </span>
            </li>
            <li class="list-group-item">
                <span>납입액 </span>
                <span class="result-price">
                    {{ setComma(this.price * this.strategyArr[1]) }}
                </span>
                <span>원</span>
                <button
                    type="button"
                    class="btn btn-link btn__more-dates"
                    data-bs-toggle="modal"
                    data-bs-target="#dateModal"
                    @click.prevent="isModalOn = true"
                >
                    다른 날짜에 납입하고 싶다면?
                </button>
            </li>
        </ul>

        <ul class="list-group list-group-horizontal-lg">
            <li class="list-group-item">
                <span>원금 합계 </span>
            </li>
            <li class="list-group-item">
                <span class="result-price"
                    >{{ setComma(this.principal) }}
                </span>
                <span>원</span>
            </li>
        </ul>
        <ul class="list-group list-group-horizontal-lg">
            <li class="list-group-item">
                <span>세전 이자 </span>
            </li>
            <li class="list-group-item">
                <span class="result-price"
                    >{{ setComma(this.interestBeforeTax) }}
                </span>
                <span>원</span>
            </li>
        </ul>
        <ul class="list-group list-group-horizontal-lg">
            <li class="list-group-item">
                <span class="tax-price"
                    >이자 과세 ({{ this.currentTax }}%)</span
                >
            </li>
            <li class="list-group-item">
                <span class="result-price tax-price"
                    >{{
                        this.interestTaxPrice
                            ? `-${setComma(this.interestTaxPrice)}`
                            : setComma(this.interestTaxPrice)
                    }}
                </span>
                <span>원</span>
            </li>
        </ul>
        <ul class="list-group list-group-horizontal-lg">
            <li class="list-group-item">
                <span>세후 수령액 </span>
            </li>
            <li class="list-group-item">
                <span class="result-price">{{ setComma(this.total) }}</span>
                <span>원</span>
            </li>
        </ul>
    </div>
    <div class="contact">
        <span>에러를 발견하였거나 필요한 기능이 있다면?</span>
        <a href="https://forms.gle/8BTPkpbdBDKPrjg49" target="_blank"
            >건의/제보하기(구글폼)</a
        >
    </div>
</template>

<script>
import { calculateSuni, simpleInterest, compoundInterest } from "../calculator";
import KakaoAds from "./KakaoAds.vue";

export default {
    name: "SuniCalculator",
    components: {
        KakaoAds,
    },
    data() {
        return {
            isModalOn: false,
            period: "",
            rate: "",
            startDate: "",
            depositDate: "",
            price: "",
            strategy: "",
            strategyArr: "",
            result: {
                firstPayDate: "",
                optimizedDate: "",
                lastPayDate: "",
                dateItems: [],
            },
            isResultFetched: false,
            dueDate: "",
            delayedDays: 0,
            strategyOptions: {
                oneYear: ["6-1-5", "1-6-5", "1-11"],
                oneYearAndHalf: ["9-1-8", "1-9-8", "1-17"],
                twentyThreeMonths: ["12-11", "11-1-11", "1-22"], // TODO: "1-11-1-10" 추가
                twoYears: ["12-1-11", "1-12-11", "1-23"],
                threeYears: ["18-1-17", "1-18-17", "1-35"],
            },
            tax: "",
            currentTax: "",
            principal: "",
            receiveBeforeTax: "",
            interestBeforeTax: "",
            interestTaxPrice: "",
            total: "",
            interestType: "",
            taxType: {
                normal: 0.154,
                low: 0.014,
                noTax: 0,
            },
            isManualActive: false,
        };
    },

    mounted() {
        let adScript = document.createElement("script");
        adScript.setAttribute("src", "//t1.kakaocdn.net/kas/static/ba.min.js");
        document.body.appendChild(adScript);
    },

    methods: {
        handleSubmit() {
            this.strategyArr = this.strategy.split("-").map((v) => parseInt(v));
            this.result = calculateSuni(
                parseInt(this.period),
                this.startDate,
                this.strategyArr
            );

            this.isResultFetched = true;
            // const dueDate = new Date(this.startDate);
            // dueDate.setMonth(dueDate.getMonth() + this.period);
            // this.dueDate = dueDate.toISOString().split("T")[0];
            // this.delayedDays = this.results.map((r) => r.slice(-1)[0]).reduce((a, b) => a + b, 0);
            this.currentTax = (this.tax * 100).toFixed(1);
            this.principal = this.price * this.period;
            this.receiveBeforeTax =
                this.interestType === "simple"
                    ? simpleInterest(this.price, this.rate, this.period)
                    : compoundInterest(this.price, this.rate, this.period);
            this.interestBeforeTax = Math.ceil(
                this.receiveBeforeTax - this.principal
            );
            this.interestTaxPrice = Math.floor(
                this.interestBeforeTax * this.tax
            );
            this.total = Math.ceil(
                this.receiveBeforeTax - this.interestTaxPrice
            );
        },

        handleOption(options) {
            return options.filter((o) => {
                if (this.startDate === this.depositDate) {
                    if (parseInt(o.split("-")[0]) !== 1) return o;
                } else {
                    if (parseInt(o.split("-")[0]) === 1) return o;
                }
            });
        },

        setComma(price) {
            const parts = price.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        },
    },

    setup() {
        return {
            calculateSuni,
            simpleInterest,
            compoundInterest,
        };
    },
};
</script>

<style>
body {
    width: 50%;
}

.accordion {
    margin: 1rem 0;
}

.heading__secondary {
    margin: 1rem 0;
}

.price__comma {
    margin-top: 5px;
    margin-bottom: 0;
}

.list-group-item {
    background-color: transparent;
    border: none;
}

.btn__more-dates {
    padding: 0;
    padding-left: 10px;
    padding-bottom: 2px;
    border: none;
    text-decoration: none;
}

.result {
    width: 100%;
    background-color: #f5f5f5;
}

.result__details > span {
    display: block;
}

.result-table {
    width: 100%;
    text-align: center;
}

.date-modal-table {
    width: 100%;
    text-align: center;
}

.modal__explain {
    margin-bottom: 0.5rem;
}

.result-price {
    font-weight: 700;
}

.tax-price {
    color: tomato;
}

.caution__text {
    font-size: 0.8rem;
    color: #808080;
    text-decoration: underline;
}

.contact {
    margin: 1rem 0;
}

@media (max-width: 900px) {
    body {
        width: 100%;
    }
    .result {
        width: 100%;
    }

    .list-group-item:last-child {
        border-bottom: solid 2px #a9a9a9;
    }
}

.adfit {
    margin: 1rem 0;
}
</style>
